import React from "react"

const InfoComponent = ({ aditionalClass, imageSide, image, title, sideContent, aditionalFirstColumn, aditionalSecondColumn, imageDesc }) => (
	<section className={`info-component ${ aditionalClass ? aditionalClass : '' }`}>
        <div className="container">
            <div className={`row info-component__holder ${ imageSide === 'left' ? 'info-component__reverse-row' : '' }`}>
                { imageSide === 'left' && 
                    <div className="col-12 col-lg-6 info-component__image">
                        <img src={ image } alt=""/>
                        { imageDesc !== undefined &&
                            <p className="image__desc">
                                { imageDesc }
                            </p>
                        }
                    </div>
                }
                <div className="col-12 col-lg-6 info-component__content">
                    {  title !== undefined &&
                        <h2 className="title-underline mb-20">
                            { title }
                        </h2>
                    }
                    <div dangerouslySetInnerHTML={{ __html: sideContent }}></div>
                </div>
                { imageSide === 'right' && 
                    <div className="col-12 col-lg-6 info-component__image">
                        <img src={ image } alt=""/>
                        { imageDesc !== undefined &&
                            <p className="image__desc">
                                { imageDesc }
                            </p>
                        }
                    </div>
                }
            </div>
            { aditionalFirstColumn !== undefined &&
                <div className="row info-component__aditional-columns">
                    <div 
                        className="col-12 col-lg-6 aditional-columns__first"
                        dangerouslySetInnerHTML={{ __html: aditionalFirstColumn }}
                    />    
                    <div 
                        className="col-12 col-lg-6 aditional-columns__second" 
                        dangerouslySetInnerHTML={{ __html: aditionalSecondColumn }}
                    />
                </div>
            }
        </div>
    </section>
)

export default InfoComponent
